import React, { useState, useEffect, useRef } from "react";

import { useParams, Link } from "react-router-dom";
import '../styles/cart.css';
import axios from 'axios';
import {Document, Page} from "react-pdf";
import config from '../config';
import { loadStripe } from "@stripe/stripe-js";
import { getCurrentUser } from 'aws-amplify/auth';

import { LuPencil } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { LuShoppingCart } from "react-icons/lu";

const host = config.backendUrl;
const stripePromise = loadStripe("pk_test_51QkZfKRqLIskEgXzaJ1JB4UL8D5pA9dhckvkXPt2uJpDyTFIM61Eo1pKMQjDj331mTKk4I2sE3QqiORGgT4DPp1S00KjOjMeRM");

export default function GiftBook({title}) {
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);

    const [recipientEmail, setRecipientEmail] = useState("")
    const [personalMessage, setPersonalMessage] = useState("")
    const [senderName, setSenderName] = useState("")
    const [promoCode, setPromoCode] = useState("")

    useEffect(() => {
        document.title = title;

        if (!host.includes("sandbox")) {
            window.location.href = "https://grieversandfriends.com/gift-a-book";
        }

        const fetchUser = async () => {
            try {
                const currentUser = await getCurrentUser();
                if (currentUser) {
                    setUser(currentUser);
                } else {
                    setUser(null);
                }
            } catch (error) {
                console.error("Error fetching user:", error);
                setUser(null);
            }
        };

        fetchUser();
    }, []);

    // const handleCheckout = async () => {
    //     try {

    //       if (recipientEmail == "" || recipientEmail == undefined || recipientEmail == null) {
    //         alert("Please enter a recipient email.");
    //         return false;
    //       } else if (senderName == "" || senderName == undefined || senderName == null) {
    //         alert("Please enter your name.");
    //         return false;
    //       }

    //       // preserve line breaks in personal message
    //       const formattedMessage = personalMessage.replace(/\n/g, "\\n");

    //       const payload = {
    //         recipient_email: recipientEmail,
    //         personal_message: formattedMessage,
    //         sender_name: senderName,
    //       }

    //       if (user) {
    //         payload.user_id = user.userId; // Assuming user ID is stored in the sub attribute
    //       }

    //       console.log("Payload for gift checkout:", payload);

    //       const response = await fetch(`${host}/api/create-gift-checkout`, {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json", "X-API-Key": process.env.REACT_APP_GANDF_KEY },
    //         body: JSON.stringify(payload),
    //       });

    //       const { url } = await response.json();
      
    //       if (url) {
    //         window.location.href = url; // Redirect user to Stripe Checkout
    //       }
    //     } catch (error) {
    //       console.error("Error creating checkout session:", error);
    //     }
    // };

    return (
        <div className="cart">

            <div className="cart-header">
                <a className="cart-back-link" href="https://grieversandfriends.com/books/">&larr;  Back to Products</a>
                <h1>A Timeless Gift for Any Season of Grief</h1>
            </div>
         
            <div className="empty-cart">
              <form action={`${host}/api/create-gift-checkout`} method="POST">
                  <p className="gift-book-header">Recipient’s Email Address</p>
                  <p className="gift-book-helper-text">We’ll send the gift code to their inbox.</p>
                  <input type="email" className="recipient-email" placeholder="name@example.com" name="recipient_email" value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} required />

                  <p className="gift-book-header">Your Name</p>
                  <p className="gift-book-helper-text">So they know it’s from you.</p>
                  <input type="text" className="recipient-email" placeholder="Your Name" name="sender_name" value={senderName} onChange={(e) => setSenderName(e.target.value)} required />

                  <div className="personal-message-container">
                      <p className="gift-book-header">Add a Personal Message (optional)</p>
                      <textarea className="personal-message" placeholder="Write your message here..." name="personal_message" value={personalMessage} onChange={(e) => setPersonalMessage(e.target.value)} maxLength={300}></textarea>

                      <div className="character-count-container">
                          <span className="character-count">{300 - personalMessage.length} characters remaining</span>
                      </div>
                  </div>

                  <p className="gift-book-header">Promo Code</p>
                    <input type="text" className="recipient-email" placeholder="Enter promo code" name="promo_code" value={promoCode} onChange={(e) => setPromoCode(e.target.value)} />
                

                  <button className="checkout-button" type="submit">Checkout</button> 
              </form>
            </div>
           
        </div>
    );
}